import {
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT
} from "../../state/modules/layout/constants";
import styles from "./MediumLargeViewportOnly.css";
import propTypes from "./propTypes";

const validViewports = [MEDIUM_VIEWPORT, LARGE_VIEWPORT];
const isMediumLarge = validViewports.includes.bind(validViewports);

const MediumLargeViewportOnly = ({ children, viewportCategory }) =>
  isMediumLarge(viewportCategory) ? (
    <div className={styles.container}>{children}</div>
  ) : null;

MediumLargeViewportOnly.displayName = "MediumLargeViewportOnly";

MediumLargeViewportOnly.propTypes = propTypes;

export default MediumLargeViewportOnly;
